__turbopack_context__.v({
  "button": "ArticleSectionComments-module-scss-module__LuPr-G__button",
  "commentsSection": "ArticleSectionComments-module-scss-module__LuPr-G__commentsSection",
  "wrapper": "ArticleSectionComments-module-scss-module__LuPr-G__wrapper",
});
